import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initializeAnalytics } from "./analytics";

// =============================
// 🌍 i18n activado
// =============================
const I18N_ENABLED = true;

// Render sin i18n (temporal)
if (!I18N_ENABLED) {
  createRoot(document.getElementById("root")!).render(<App />);
} else {
  // --- i18n (multi-idioma) ---
  import("i18next").then(async ({ default: i18n }) => {
    const { initReactI18next, I18nextProvider } = await import("react-i18next");
    const { default: LanguageDetector } = await import("i18next-browser-languagedetector");

    // Carga de recursos de traducción (asegúrate de tener estos JSON)
    const es = (await import("./locales/es.json")).default;
    const en = (await import("./locales/en.json")).default;
    const de = (await import("./locales/de.json")).default;
    const it = (await import("./locales/it.json")).default;
    const fr = (await import("./locales/fr.json")).default;
    const pt = (await import("./locales/pt.json")).default;

    await i18n
      .use(LanguageDetector)
      .use(initReactI18next)
      .init({
        resources: {
          es: { translation: es },
          en: { translation: en },
          de: { translation: de },
          it: { translation: it },
          fr: { translation: fr },
          pt: { translation: pt },
        },
        fallbackLng: "en",
        detection: {
          order: ["querystring", "localStorage", "navigator", "htmlTag"],
          caches: ["localStorage"]
        },
        interpolation: { escapeValue: false },
        debug: false
      });

    const setHtmlLang = (lng?: string) => {
      if (lng) document.documentElement.lang = lng;
    };
    setHtmlLang(i18n.resolvedLanguage || i18n.language);
    i18n.on("languageChanged", (lng) => setHtmlLang(lng));

    createRoot(document.getElementById("root")!).render(
      <I18nextProvider i18n={i18n}>
        <App />
      </I18nextProvider>
    );

    // Initialize GA4 event tracking
    initializeAnalytics();
  });
}